import { render, staticRenderFns } from "./WritingReviewedNotification.vue?vue&type=template&id=56db42bd&"
import script from "./WritingReviewedNotification.vue?vue&type=script&lang=js&"
export * from "./WritingReviewedNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports